import { Dtos, FileClassificationStatus } from "@inrev/common";

export const CLASSIFICATION_POLL_INTERVAL_MS = 15_000; // 15 seconds

export const CLASSIFICATION_POLL_MAX_MS =
	Dtos.PromptRunner.Classification.CLASSIFICATION_TIMEOUT_MINUTES * 60 * 1_000;

export const isClassificationPendingStatus = (
	status: FileClassificationStatus | undefined,
): boolean =>
	status === FileClassificationStatus.pending || status === FileClassificationStatus.not_started;
